import api from "./api";

export async function fetchStockCatalogs(includeInactive = false) {
  const params = includeInactive ? { include_inactive: true } : {};

  const [categoriesResponse, subcategoriesResponse, suppliersResponse, locationsResponse] = await Promise.all([
    api.get("/stock/categories", { params }),
    api.get("/stock/subcategories", { params }),
    api.get("/stock/suppliers", { params }),
    api.get("/stock/locations", { params }),
  ]);

  return {
    categories: Array.isArray(categoriesResponse.data) ? categoriesResponse.data : [],
    subcategories: Array.isArray(subcategoriesResponse.data) ? subcategoriesResponse.data : [],
    suppliers: Array.isArray(suppliersResponse.data) ? suppliersResponse.data : [],
    locations: Array.isArray(locationsResponse.data) ? locationsResponse.data : [],
  };
}
